import React, { useState } from 'react';
import { Button, VisuallyHidden } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import ItemCancelModal from './ItemCancelModal';
import { useLineItemData } from '../../contexts/LineItemDataProvider';

/**
 * A text button that allows the customer to initiate a cancellation of that item.
 * @returns {JSX.Element}
 */
export const ItemCancelButton = ({ ...buttonProps }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [customerCancelMessages] = useTranslations(['customerCancelMessages']);
  const { productName } = useLineItemData();

  return (
    <>
      <ItemCancelModal
        isModalOpen={modalIsOpen}
        setModalAsOpen={setModalIsOpen}
      />
      <Button
        onClick={() => setModalIsOpen(true)}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...buttonProps}
      >
        {customerCancelMessages.cancelButtonText}
        <VisuallyHidden>{`: ${productName}`}</VisuallyHidden>
      </Button>
    </>
  );
};
